export default __webpack_public_path__ + "static/media/filled-plus.af38faed.svg";